import React, { useContext } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import AuthContext from "connections/auth/AuthProvider.js";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    maxHeight: "90vh",
    overflowY: "auto",
    borderRadius: "8px",
    overflow: "hidden",
  },
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    height: "80vh",
    maxHeight: "800px",
  },
  titleSection: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: "5px 5px 0px 0px",
    backgroundColor: "#f5f5f5",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(6),
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },
  title: {
    fontSize: "1.1rem",
    margin: 0,
    color: theme.palette.text.primary,
    textTransform: "none",
  },
  closeIconButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.text.secondary,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  contentSection: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(3),
  },
  placeholderContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  placeholderIcon: {
    fontSize: "4rem",
    opacity: 0.3,
  },
  placeholderLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: theme.palette.text.disabled,
    backgroundColor: "#f5f5f5",
    padding: "4px 12px",
    borderRadius: "12px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
}));

export default function ModalChainMonitoring({ open, onClose, programId }) {
  const { userDetails } = useContext(AuthContext);
  const classes = useStyles({ clientColor: userDetails.implementation_color });
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="chain-monitoring-modal-title"
      aria-describedby="chain-monitoring-modal-description"
    >
      <Box className={classes.modalBox}>
        <Box className={classes.modalContainer}>
          {/* Header Section */}
          <Box className={classes.titleSection}>
            <Typography variant="h6" className={classes.title}>
              {t("rgm.executive.channels.chain_monitoring.drawer_title")}
            </Typography>
            <IconButton
              onClick={onClose}
              className={classes.closeIconButton}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content Section */}
          <Box className={classes.contentSection}>
            <Box className={classes.placeholderContent}>
              <Typography
                variant="caption"
                className={classes.placeholderLabel}
              >
                CH.2 - DETAILS
              </Typography>
              <SearchIcon className={classes.placeholderIcon} />
              <Typography variant="h6" color="textSecondary">
                Chain Monitoring Details
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Placeholder - Análise detalhada de monitoramento de cadeia
                <br />
                Gráficos e visualizações serão implementados aqui
              </Typography>
              {programId && (
                <Typography variant="caption" color="textSecondary">
                  Program ID: {programId}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

ModalChainMonitoring.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  programId: PropTypes.number,
};
